import { FC } from 'react';
import SyncingActive from '@/components/UI/SyncingActive/SyncingActive';
import ErrorFilterLink from '@/components/UI/ErrorFilterLink/ErrorFilterLink';
import { FilterTypes as filterType } from '@/constants/FilterTypes';

interface FilterConfig {
  categoryValue: string; // 'sync_status' or 'backfill_status'
  categoryIndex: number; // filter category index, usually 2
}

interface BenchlingSyncStatusAsideProps {
  errorCount: number;
  filterConfig: FilterConfig;
  useTableProps: any;
  testId?: string;
}

const BenchlingSyncStatusAside: FC<BenchlingSyncStatusAsideProps> = ({
  errorCount,
  filterConfig,
  useTableProps,
  testId = 'view-errors-link',
}) => {
  const handleViewErrorsClick = () => {
    // Create a proper filter object for status=failed
    const statusFilter = {
      category: {
        name: 'Status',
        value: filterConfig.categoryValue,
        index: filterConfig.categoryIndex,
      },
      operation: {
        name: filterType.eq, // Use FilterTypes constant: 'is equal to'
        index: 0, // 'eq' operation is at index 0
      },
      option: {
        name: 'Failed',
        value: 'failed',
      },
    };

    useTableProps.apiTable.addFilter(statusFilter);
  };

  return (
    <div className="flex flex-column items-end">
      <SyncingActive />
      {errorCount > 0 && (
        <div className="mt2">
          <ErrorFilterLink errorCount={errorCount} onViewErrorsClick={handleViewErrorsClick} testId={testId} />
        </div>
      )}
    </div>
  );
};

export default BenchlingSyncStatusAside;
